import { z } from 'zod/v4';

export const addFamilyMemberSchema = z.object({
  // Can be either telegram username (with @) or telegram ID
  telegramId: z.number().int('Telegram ID должен быть целым числом').optional(),
  telegramUsername: z.string()
    .min(1, 'Имя пользователя не может быть пустым')
    .max(100, 'Имя пользователя слишком длинное (максимум 100 символов)')
    .optional(),
  // Универсальный идентификатор (username, telegramId или телефон)
  identifier: z.string()
    .min(1, 'Идентификатор не может быть пустым')
    .max(100, 'Идентификатор слишком длинный (максимум 100 символов)')
    .optional(),
  // ID пользователя (для выбора из результатов поиска)
  userId: z.number().int('ID пользователя должен быть целым числом').optional(),
}).refine(data => data.telegramId || data.telegramUsername || data.identifier || data.userId, {
  message: 'Необходимо указать telegramId, telegramUsername, identifier или userId',
});

export const searchUsersSchema = z.object({
  query: z.string({ message: 'Поисковый запрос обязателен' })
    .min(1, 'Поисковый запрос не может быть пустым')
    .max(100, 'Поисковый запрос слишком длинный (максимум 100 символов)'),
  limit: z.coerce.number()
    .int('Лимит должен быть целым числом')
    .min(1, 'Лимит должен быть >= 1')
    .max(50, 'Лимит должен быть <= 50')
    .optional()
    .default(10),
});

export const removeFamilyMemberSchema = z.object({
  reason: z.string().max(500, 'Причина слишком длинная (максимум 500 символов)').optional(),
});

export const changeFamilySlotsSchema = z.object({
  newSlots: z.number({ message: 'Количество слотов обязательно' })
    .int('Количество слотов должно быть целым числом')
    .min(1, 'Минимум 1 слот')
    .max(20, 'Максимум 20 слотов'),
});

export type AddFamilyMemberInput = z.infer<typeof addFamilyMemberSchema>;
export type SearchUsersInput = z.infer<typeof searchUsersSchema>;
export type RemoveFamilyMemberInput = z.infer<typeof removeFamilyMemberSchema>;
export type ChangeFamilySlotsInput = z.infer<typeof changeFamilySlotsSchema>;

// ==================== Response Types ====================

/**
 * Результат поиска пользователей для семейной подписки
 */
export interface FamilyUserSearchResult {
  id: number;
  telegramId: number;
  username: string | null;
  firstName: string | null;
  lastName: string | null;
  email: string | null;
  phoneNumber: string | null;
}
